<template>
  <div>
    <div class="float-btn" @click="goToMyMatters">火化证明</div>
    <div class="bodyTransfer bodyTransfer2">
      <div style="color:red;margin-left:10px;margin-top:10px;">
        <p>适用情形：</p>
        <p>
          在江苏省内死亡的本省户籍人员，由其继承人作为申请人申请办理身后相关事项。
        </p>
        <p>
          火化证明电子证照成功出具后，点击右侧”火化证明“蓝色按钮，可查询、下载。
        </p>
      </div>
      <div class="formTitle">办理事项要求</div>
      <img class="close" src="@/assets/img/close.png" alt="" @click="close">

      <div class="businessList" v-for="(items,index) in businessList" :key="index">
        <div class="title">
          <img :src="items.icon" alt="">
          <p>{{items.name}}</p>
        </div>
        <div class="tableth">
          <div class="index">序号</div>
          <!-- <div class="department">办理部门</div> -->
          <div>联办事项</div>
          <div>受理条件</div>
          <div>办理材料</div>
        </div>
        <div class="tableBody" v-for="(item,i) in items.itemList" :key="i">
          <div class="index">
            <p>{{i+1}}</p>
          </div>
          <!--           <div class="department">{{item.department}}</div> -->
          <div>{{item.matter}}
            <!--            <div class="btn">-->
            <!--              <p @click="toTransact(item)">办理此业务</p>-->
            <!--            </div>-->
          </div>
          <div v-html="item.condition"></div>
          <div v-html="item.file"></div>
        </div>
      </div>

      <!--      <div class="title">-->
      <!--        <img src="@/assets/img/icon7.png" alt="">-->
      <!--        <p>需要证件</p>-->
      <!--      </div>-->
      <!--      <div class="certificate">-->
      <!--        <div class="name">共享电子证照</div>-->
      <!--        <div class="content">-->
      <!--            <p>1、死亡证明或者火化证明</p>-->
      <!--            <p>2、申请人身份证，逝者身份证</p>-->
      <!--            <p>3、与逝者关系证明表</p>-->
      <!--            <p>4、银行卡复印件</p>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="btns" >
<!--        <el-button style="margin-bottom: 150px" type="primary" plain round @click="lastStep()">上一步</el-button>-->
        <el-button style="margin-bottom: 150px" type="primary" round @click="toTransact()">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getBusinessList } from "@/api/api";
import {getCustomByTicket} from "@/api/zwfwLogin";
export default {
  components: {},
  data() {
    return {
      businessList:[],
      businessList2: [
        {
          name: "注销类",
          icon: require("@/assets/img/icon4.png"),
          itemList: [
            {
              department: "公安",
              matter: "注销户口",
              condition: "逝者为正常死亡的江苏籍户籍人口",
              file: `<p>1. 死亡证明</p>
                    <p>2. 逝者证件信息</p>
                    <p>3. 申请人证件信息</p>
                    <p>4. 逝者居民户口簿</p>`,
            },
            {
              department: "公安",
              matter: "驾驶证注销",
              condition: "公民死亡",
              file: `<p>1. 死亡证明</p>
                    <p>2. 逝者证件信息</p>
                    <p>3. 申请人证件信息</p>`,
            },
            {
              department: "人社",
              matter: "社会保障卡注销",
              condition: "公民死亡",
              file: `<p>1. 死亡证明</p>
                    <p>2. 逝者证件信息</p>
                    <p>3. 申请人证件信息</p>
                    <p>4. 关系证明</p>
                    <p>5. 社会保障卡</p>`,
            },
            {
              department: "残联",
              matter: "注销户口",
              condition: "公民死亡",
              file: `<p>1. 死亡证明</p>
                    <p>2. 逝者证件信息</p>
                    <p>3. 申请人证件信息</p>`,
            },
          ],
        },
        {
          name: "申领类",
          icon: require("@/assets/img/icon5.png"),
          itemList: [
            {
              department: "人社",
              matter:
                  "企业职工因病或非因工死亡遗属待遇及个人账户储存额（余额）申领",
              condition:
                  "参保人员或者退休人员死亡的，有个人账户储存额或者余额需要清退的",
              file: `<p>1. 死亡证明</p>
                    <p>2. 逝者证件信息</p>
                    <p>3. 申请人证件信息</p>
                    <p>4. 关系证明</p>
                    <p>5. 社会保障卡/银行卡信息</p>
                    <p>6. 遗属信息</p>`,
            },
            // {
            //   department: "人社",
            //   matter: "个人账户一次性待遇申领",
            //   condition: "未申领过江苏省社会保障卡",
            //   file: `<p>1. 死亡证明</p>
            //         <p>2. 逝者证件信息</p>
            //         <p>3. 申请人证件信息</p>
            //         <p>4. 关系证明</p>
            //         <p>5. 社会保障卡/银行卡信息</p>
            //         <p>6. 遗属信息</p>`,
            // },
            {
              department: "人社",
              matter: "社会保障卡申领",
              condition: "死亡且未终止的城乡居民基本养老保险参保人员",
              file: `<p>1. 死亡证明</p>
                    <p>2. 逝者证件信息</p>
                    <p>3. 申请人证件信息</p>
                    <p>4. 关系证明</p>`,
            },
            // {
            //   department: "人社",
            //   matter: "城乡居民参保关系注销登记人员待遇核准支付",
            //   condition: "职工死亡或被宣告死亡且职工住房公积金账户已封存",
            //   file: `<p>1. 死亡证明</p>
            //         <p>2. 逝者证件信息</p>
            //         <p>3. 申请人证件信息</p>
            //         <p>4. 关系证明</p>
            //         <p>5. 社会保障卡/银行卡信息</p>
            //         <p>6. 遗属信息</p>`,
            // },
            {
              department: "住建",
              matter: "住房公积金提取（死亡）",
              condition: "职工死亡或被宣告死亡且职工住房公积金账户已封存",
              file: `<div class="file">
                    <div class="name">（一）死者相关材料</div>
                    <p>1. 死亡证明</p>
                    <p>2. 死者户籍材料</p>
                    <p>3. 死者银行卡（I类） </p>

                    <div class="name">（二）继承人或受遗赠人相关材料</div>
                    <p>1. 继承或受遗赠文件(经公证机关办理具有法律效力）</p>
                    <p>2. 身份证</p>

                    <div class="name">（三）申请人相关材料</div>
                    <p>1. 申请人证件信息</p>
                    <p>2. 公证书</p>
              </div>`,
            },
            {
              department: "医保",
              matter: "参保部门个人账户一次性支取（基本医疗保险）",
              condition: `1. 参保人员死亡的，且为我省职工基本医疗保险正常参保对象；<br/>
                2. 参保人员在定点医疗机构费用已全部结算完毕，无欠费。`,
              file: `<p>1. 死亡证明</p>
                    <p>2. 逝者证件信息</p>
                    <p>3.  参保人社会保障卡/银行卡信息（由家属代领的，需提供参保人指  定受益人或法定继承人有效身份证件、社会保障卡或银行卡及相关承诺书等材料）</p>`,
            },
          ],
        },
        {
          name: "停发类",
          icon: require("@/assets/img/icon6.png"),
          itemList: [
            {
              department: "民政",
              matter: "尊老金待遇停发",
              condition: "自然人死亡",
              file: `<p>1. 死亡证明</p>
                    <p>2. 逝者证件信息</p>
                    <p>3. 申请人证件信息</p>`,
            },
            {
              department: "民政",
              matter: "最低生活保障待遇停发",
              condition: "自然人死亡",
              file: `<p>1. 死亡证明</p>
                    <p>2. 逝者证件信息</p>
                    <p>3. 申请人证件信息</p>`,
            },
            {
              department: "民政",
              matter: "特困供养人员待遇停发",
              condition: "自然人死亡",
              file: `<p>1. 死亡证明</p>
                    <p>2. 逝者证件信息</p>
                    <p>3. 申请人证件信息</p>`,
            },
            {
              department: "民政",
              matter: "社会保险待遇暂停（城乡居民养老保险待遇）",
              condition: "自然人死亡",
              file: `<p>1. 死亡证明</p>
                    <p>2. 逝者证件信息</p>
                    <p>3. 申请人证件信息</p>`,
            },
            {
              department: "民政",
              matter: "残疾人两项补贴待遇停发",
              condition: "自然人死亡",
              file: `<p>1. 死亡证明</p>
                    <p>2. 逝者证件信息</p>
                    <p>3. 申请人证件信息</p>`,
            },
            {
              department: "人社",
              matter: "暂停社会保险定期待遇",
              condition: "企业离退休人员去世、企业供养直系亲属去世的",
              file: `<p>1. 死亡证明</p>
                    <p>2. 逝者证件信息</p>
                    <p>3. 申请人证件信息</p>
                    <p>4. 关系证明</p>`,
            },
            {
              department: "医保",
              matter: "基本医疗保险待遇暂停",
              condition: "参保人员死亡",
              file: `<p>1. 死亡证明</p>
                    <p>2. 逝者证件信息</p>
                    <p>3. 申请人证件信息</p>`,
            },
          ],
        },
      ],
    };
  },
  computed: {},

  // ===== 新增变化时重试（v-show 切回来时组件不重建） =====
  watch: {
    "$route.path"(toPath) {
      if (
          toPath === "/" ||
          toPath === "/bodyTransfer" ||
          toPath === "/oneThing"
      ) {
        if (!this.businessList || this.businessList.length === 0) {
          this.getlist(0);
        }
      }
    },
  },

  methods: {
    lastStep() {
      console.log("上一步")
    },
    toTransact(e) {
      this.$router.push({
        path: "/selectBusiness",
        query: e,
      });
    },
    close(){
      this.$router.push({
        path:'/'
      })
    },
    async getlist() {
      // ---- 第一步：确保 sessionStorage 里有 ticket ----
      let ticket = sessionStorage.getItem("ticket");
      if (!ticket || ticket.trim() === '') {
        ticket = this.$route.query.ticket
            || new URLSearchParams(window.location.search).get('ticket');
        if (ticket && ticket.trim()) {
          sessionStorage.setItem("ticket", ticket);
        }
      }

      // ---- 第二步：没 ticket 直接放弃 ----
      if (!ticket || !ticket.trim()) {
        this.businessList = [];
        return;
      }

      // ---- 第三步：没 customData → 自己主动调 API 拿（不等 topHeader）----
      let customData = sessionStorage.getItem("customData");
      if (!customData) {
        try {
          const res = await getCustomByTicket({ ticket });
          if (res && res.data) {
            customData = JSON.stringify(res.data);
            sessionStorage.setItem("customData", customData);
          }
        } catch (e) {
          console.warn('[nav] getCustomByTicket 失败:', e);
        }
      }

      // ---- 第四步：ticket ✅ + customData ✅ → 调 getBusinessList ----
      if (!customData) {
        this.businessList = [];
        return;
      }

      try {
        const data = await getBusinessList({});
        if (data && data.data && Array.isArray(data.data) && data.data.length > 0) {
          this.businessList = data.data;
        } else {
          this.businessList = [];
        }
        this.$nextTick(() => {
          document.documentElement.scrollTop = 900;
        });
      } catch (err) {
        this.businessList = [];
      }
    },
    goToMyMatters(){
      this.$router.push({
        path:'/myMatters'
      })
    }
  },

  // ===== created 触发（原来有，保持不变） =====
  created() {
    this.getlist(0);
  },

  // ===== mounted 兜底再试一次（如果 created 还没等到） =====
  mounted() {
    if (!this.businessList || this.businessList.length === 0) {
      this.getlist(0);
    }
  },
};
</script>
<style scoped lang="scss">
.btns {
  display: flex;
  justify-content: center;
  margin: 80px 0;

  button {
    margin: 0 10px;
    width: 159px;
    height: 48px;
    font-size: 22px;
    border-radius: 36px;

    &:nth-child(1) {
      // background: #fff;
    }

    &:nth-child(2) {
      font-weight: bold;
    }
  }
}

/* 右侧悬浮火化证明按钮 */
.float-btn {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 72px;
  height: 200px;
  background: linear-gradient(180deg, #409eff 0%, #1677ff 100%);
  color: #fff;
  font-size: 20px;
  line-height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  writing-mode: vertical-rl;
  text-orientation: upright;
  border-radius: 36px;
  cursor: pointer;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(22, 119, 255, 0.4);
  transition: all 0.3s ease;
  letter-spacing: 6px;
  padding: 15px 0;
  font-weight: bold;

  &:hover {
    background: linear-gradient(180deg, #66b1ff 0%, #409eff 100%);
    box-shadow: 0 6px 16px rgba(22, 119, 255, 0.55);
    transform: translateY(-50%) scale(1.05);
  }
}
</style>
